/**
 * Messages Store - Main Entry
 * Модульный store для работы с сообщениями
 *
 * Разделен на:
 * - types.ts    - все типы и интерфейсы
 * - state.ts    - начальное состояние
 * - utils.ts    - нормализация и утилиты
 * - actions.ts  - все actions с offline-first поддержкой
 */

import { defineStore } from 'pinia';
import { createInitialState } from './state';
import { createActionsWithOffline } from './actions';

// Re-export types for external use
export type {
  MessagesState,
  MessageStatusCache,
  SendMessagePayload,
  MarkReadPayload,
  MessageReadEventData,
  MessageUpdatePatch,
  MergeMessagesResult,
  DeliveryStatus,
} from './types';

// Re-export utility functions
export {
  normalizeConversation,
  normalizeMessage,
  normalizeUnreadCounters,
  normalizeTimestampSeconds,
  mergeMessagesWithDedup,
  updateMessagesHeaderBadge,
  updateConversationOrder,
  updateConversationAndMoveToTop,
  checkMessageDeliveryStatus,
  generateTempId,
  sumUnread,
} from './utils';

// ===== Store Definition =====

export const useMessagesStore = defineStore('messages', {
  state: createInitialState,
  actions: createActionsWithOffline(),
});

// ===== Global Access =====

// Export sync function for external access (matches Angular)
(window as any).refreshVueMessages = async () => {
  const store = useMessagesStore() as any;
  await store.syncPendingMessages();
};

// Legacy export for backward compatibility
export { useMessagesStore as default };
